import { createAsyncThunk } from "@reduxjs/toolkit";
import { IExchangeRatesResponse } from "../exchangeRates/thunkActions";
import axios from "utils/http";
import { BENEFICIARY } from "constants/api";

export interface IUpdateBeneficiariesArgs extends ReduxAction {
  payload: any;
  id: number;
}

export const fetchBeneficiaries = createAsyncThunk(
    BENEFICIARY.LIST,
    async (
        { page, queries, onFailure }: ReduxAction,
        { rejectWithValue }
    ) => {
        try {
        const searchParams = new URLSearchParams();

        if (Object.values(queries)?.length) {
            Object.entries(queries).forEach(([key, value]:any) => {
            if (value) {
                searchParams.append(`${key}`, value);
            }
            });
        }

        const { data }: IExchangeRatesResponse = await axios.get(`${BENEFICIARY.LIST}?page=${page}`, {
            params: searchParams,
        });

        return data;
        } catch (error) {
        if (onFailure) onFailure(error as IErrorResponse);
        return rejectWithValue({ error });
        }
    }
);

export const fetchSingleBeneficiary = createAsyncThunk(
    BENEFICIARY.DETAIL,
    async ({ id, onFailure }: any, { rejectWithValue }) => {
        try {
        const { data }: any = await axios.get(
            BENEFICIARY.DETAIL.replace(":id", String(id))
        );

        return data;
        } catch (error) {
        if (onFailure) onFailure(error as IErrorResponse);
        return rejectWithValue({ error });
        }
    }
);

export const updateBeneficiaryScreeningStatus = createAsyncThunk(
    BENEFICIARY.UPDATE_SCREENING_STATUS,
    async (
        { payload, id, onSuccess, onFailure }: IUpdateBeneficiariesArgs,
        { rejectWithValue }
    ) => {
        try {
        const { message }: ApiResponse = await axios.post(
            BENEFICIARY.UPDATE_SCREENING_STATUS.replace(":id", String(id)),
            payload
        );
        if (onSuccess) onSuccess(message);
        return message;
        } catch (error) {
        if (onFailure) onFailure(error as IErrorResponse);
        return rejectWithValue({ error });
        }
    }
);
